module.exports = __webpack_public_path__ + "static/vancouver-eadf7503a525f9895a195e817e0cf880.jpg";